'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createCookie = exports.createCookie = function createCookie(name, value, days) {
  var expires = void 0;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/';
};

var getCookie = exports.getCookie = function getCookie(cname) {
  if (document.cookie.length > 0) {
    var cstart = document.cookie.indexOf(cname + '=');
    if (cstart !== -1) {
      cstart = cstart + cname.length + 1;
      var cend = document.cookie.indexOf(';', cstart);
      if (cend === -1) {
        cend = document.cookie.length;
      }
      return unescape(document.cookie.substring(cstart, cend));
    }
  }
  return '';
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/clientUtils.js
// module id = 1217
// module chunks = 0